export default __webpack_public_path__ + "static/media/USK_12.3bec7f34.png";